export default __webpack_public_path__ + "static/media/Pistol_4.1f6363b5.png";